import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import FacetsBlock from './FacetsBlock/FacetsBlock';
import CaseLookup from './CaseLookup/CaseLookup';
import LayoutOfPacerSearch from '../../containers/LayoutOfPacerSearch';
import ReportsTab from './SearchCourtRecords/ReportsTab/ReportsTab';
import './filings.less';
import { isCourtDrive } from '../../util/globalUtils';


const tabs = [
  {
    segment: 'search-court-filings',
    label: 'Case Lookup',
    route: '/filings/search-court-filings',
    component: CaseLookup,
  },
  {
    segment: 'search-bankruptcy-records',
    label: 'Pacer Search',
    route: '/filings/search-bankruptcy-records',
    component: LayoutOfPacerSearch,
  },
  {
    segment: 'search-bankruptcy-reports',
    label: 'Reports',
    route: '/filings/search-bankruptcy-reports',
    component: ReportsTab,
  },
];

const Filings = (props) => {
  const { tab } = props.match.params;
  const SelectedForm = _.find(tabs, ['segment', tab]).component;

  const tabsSelector = tabs.map((p) => {
    const selectedCls = (tab === p.segment)
      ? 'ui-state-default ui-tabs-selected ui-state-active'
      : 'ui-state-default';

    return (
      <li className={selectedCls} key={p.segment}>
        <Link to={p.route}><span>{p.label}</span></Link>
      </li>
    );
  });

  const headerText = isCourtDrive()
    ? 'Access bankruptcy, civil, and criminal cases across all districts nationwide'
    : 'Access bankruptcy cases across all districts nationwide';

  return (
    <div className="filings filings-page">

      <FacetsBlock type="filings" />

      <div className="filings-forms">
        <h1 className="title">Search Court Records</h1>

        <h4>{headerText}</h4>

        <ul className="ui-tabs-nav ui-helper-reset ui-helper-clearfix filings-forms-tabs">
          { tabsSelector }
        </ul>
        <div className="inside-block ui-tabs-panel ui-widget-content ui-corner-bottom">
          <SelectedForm history={props.history} />
        </div>
      </div>
    </div>
  );
};

Filings.propTypes = {
  match: PropTypes.any.isRequired,
};

export default Filings;



/** WEBPACK FOOTER **
 ** ./src/pages/filings/Filings.jsx
 **/